// extracted by mini-css-extract-plugin
module.exports = {"pl":"DetailBottomPlaceholder_pl__3m9ad","borderTop":"DetailBottomPlaceholder_borderTop__xAfaa"};